import { request } from "./client";
import type { SongDetail } from "./types";

export function getSong(jobId: string): Promise<SongDetail> {
  return request<SongDetail>(`/api/songs/${jobId}`);
}
